package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class StaffRepository(private val httpClient: HttpClient) {
    suspend fun getStaff(workplaceId: Long): Result<List<StaffMemberDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/staff").body()
    }

    suspend fun addStaff(workplaceId: Long, req: AddStaffRequest): Result<Long> = runCatching {
        val response = httpClient.post("workplaces/$workplaceId/staff") { setBody(req) }
        if (!response.status.isSuccess()) {
            val body = runCatching { response.body<Map<String, String>>() }.getOrNull()
            val msg = body?.get("error") ?: "Kunde inte lägga till personal (${response.status.value})."
            throw Exception(msg)
        }
        val data = response.body<Map<String, Long>>()
        data["id"] ?: throw Exception("Kunde inte lägga till personal.")
    }

    suspend fun updateStaff(workplaceId: Long, userId: Long, req: UpdateStaffRequest): Result<Unit> = runCatching {
        val response = httpClient.put("workplaces/$workplaceId/staff/$userId") { setBody(req) }
        if (!response.status.isSuccess()) {
            val body = runCatching { response.body<Map<String, String>>() }.getOrNull()
            val msg = body?.get("error") ?: "Kunde inte uppdatera personal (${response.status.value})."
            throw Exception(msg)
        }
    }

    suspend fun inviteStaff(workplaceId: Long, req: InviteStaffRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/invite") { setBody(req) }
    }

    suspend fun updateSalary(workplaceId: Long, userId: Long, req: UpdateStaffSalaryRequest): Result<Unit> = runCatching {
        httpClient.put("workplaces/$workplaceId/staff/$userId/salary") { setBody(req) }
    }

    suspend fun resendInvitation(workplaceId: Long, userId: Long): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/staff/$userId/resend-invitation")
    }

    suspend fun setActive(workplaceId: Long, userId: Long, active: Boolean): Result<Unit> = runCatching {
        httpClient.patch("workplaces/$workplaceId/staff/$userId/active") {
            setBody(SetActiveRequest(active))
        }
    }

    suspend fun getMyStats(workplaceId: Long): Result<StaffStatsDto> = runCatching {
        httpClient.get("workplaces/$workplaceId/my-stats").body()
    }

    suspend fun exitSlot(claimId: Long): Result<Unit> = runCatching {
        httpClient.delete("claims/$claimId/exit")
    }
}
